import React from 'react';
import { useParams } from 'react-router-dom';
import ParlamentarService from '../../services/ParlamentarService';
import Main from '../main/Main';
import { Grid, Paper } from '@mui/material';
import useStyles from '../../components/layout/Styles';
import { IParlamentar } from '../../models/Parlamentar.Model';
import ParlamentarCarouselTabs from '../parlamentar/_components/ParlamentarCarouselTabs'
// import _ from 'lodash';
import ParlamentarConsultaHeader from '../parlamentar/_components/ParlamentarConsultaHeader';
import { ParlamentarConsultaBotoes } from '../parlamentar/_components/ParlamentarConsultaBotoes';
import { ParlamentarConsultaInicio } from '../parlamentar/_components/ParlamentarConsultaInicio';
import { ParlamentarConsultaInformacoes } from '../parlamentar/_components/ParlamentarConsultaInformacoes';
import { ParlamentarConsultaMenuParlamentar } from '../parlamentar/_components/ParlamentarConsultaMenuParlamentar';
import { useQuery } from '../../utils/utils';
import { GerUsuariosConsultaBotoes } from './_components/GerUsuariosConsultaBotoes';
import GerUsuariosConsultaHeader from './_components/GerUsuariosConsultaHeader';
import GerUsuariosCarouselTabs from './_components/GerUsuariosCarouselTabs';
import { GerUsuariosConsultaInicio } from './_components/GerUsuariosConsultaInicio';
import { GerUsuariosConsultaInformacoes } from './_components/GerUsuariosConsultaInformacoes';
import UsuarioService from '../../services/UsuarioService';
import { IUser, IUserDpto } from '../../models/User.Model';
import { useAuthorization } from '../../contexts/AuthorizationContext';
import { AnyDate } from 'react-date-range';

export default function GerenciamentoUsuario(): JSX.Element {


    const classes = useStyles();
    const [usuario, setUsuario] = React.useState<IUser>()
    const [departamentosList, setDepartamentosList] = React.useState([]);
    const qry = useQuery().get('filtro');
    const { user } = useAuthorization();
    const id = Number(`${user?.id}`);

    React.useEffect(() => {
        loadUsuario()
        loadDepartamentos()
    }, [id])

    const loadUsuario = () => {
        if (id)
            UsuarioService
                .Get(Number(id))
                .then(usuario => usuario && setUsuario(usuario[0]));
    }

    const loadDepartamentos = () => {


        UsuarioService.GetUserDpto(Number(id)).then(res => {
            
            
            const dptos =   res.map(departamento => {
                return {
                    id: departamento.id,
                    descricao: departamento.descricao,
                }
            })
            
            
            
            
            setDepartamentosList(dptos);
            
        })
        
        
        
        
        
    }
    

    return (
        <div className={classes.root}>
            <Main>
                <Grid container justifyContent="space-around">
                    {/* ref={divRef} */}
                    <Paper style={{ borderRadius: "7px", width: "100%" }} >
                        {/* Parlamentar Header */}
                        <GerUsuariosConsultaHeader usuario={usuario} />
                        {/* ---------------- BOTOES ---------------------  */}
                        <GerUsuariosConsultaBotoes usuario={usuario} idUser={id} onChange={loadUsuario} />
                        {/* Parlamentar Inicio */}
                        <GerUsuariosConsultaInicio usuario={usuario} departamentosList={departamentosList} />
                        {/* Informações */}
                        <GerUsuariosConsultaInformacoes usuario={usuario}  departamentosList={departamentosList}/>
                    </Paper>
                    {
                        user.id_permissao !== 2 ?
                            <Grid container style={{ paddingTop: "30px" }}>
                                <Grid item style={{ width: "100%" }}>
                                    <GerUsuariosCarouselTabs id_user={Number(id)} query={qry} onChange={loadUsuario} usuario={usuario} />
                                </Grid>
                            </Grid>

                            :
                            null
                    }
                </Grid>
            </Main>
        </div>
    );
}